import request from 'tools/request'

const widgetApiUrl = process.env.REACT_APP_WIDGET_API_URL

export interface IInvitationRecipients {
  agentEmails?: string[]
  brokerEmails?: string[]
}

export const buildInvitationBody = (
  uniqueIds?: any,
  recipients?: IInvitationRecipients
): any => {
  const body: any = { ...(uniqueIds ?? {}) }
  if (recipients?.agentEmails?.length) {
    body.agentEmails = recipients.agentEmails
  }
  if (recipients?.brokerEmails?.length) {
    body.brokerEmails = recipients.brokerEmails
  }
  return Object.keys(body).length > 0 ? body : null
}

export const submitCarrierInvitation = async (
  formData: any,
  apiKey: any,
  uniqueIds?: any,
  recipients?: IInvitationRecipients
) => {
  const payload = buildInvitationBody(uniqueIds, recipients)
  const res = await request.put(`${widgetApiUrl}carriers/invitation`, payload, {
    params: {
      apiKey: apiKey,
      ...formData,
    },
    headers: {
      'Content-Type': 'application/json', 
    },
  })
  const data: any = res?.data;
  const filteredData = {
    ...data, eldInfo: data?.eldInfo.filter((item: { showCobList: boolean }) => item?.showCobList === true),
    removedElds: data?.eldInfo.filter((item: { showCobList: boolean }) => item?.showCobList === false)
  }
  return filteredData
}

// Best-effort side channel enriching the Intercom Lead/ticket already created at invite time --
// caller is expected to .catch() this, same as updateLastCheckedEld; a failure here must never
// block the carrier's actual onboarding flow.
export const syncIntercomOnboardingProgress = async (invitationKey: any, progress: {
  tspSelected?: string
  onboardingStatus?: string
  credentialFailureCount?: number
}) => {
  return request.put(`${widgetApiUrl}carriers/${invitationKey}/intercom-progress`, progress)
}
